import { Bookmark, NavigationData } from 'core/slices/models';
import { findReport } from 'domain/functions/findReport';

/**
 * adds the bookmark to the bookmarks array on the report provided by reportId
 * @param data
 * @param reportId
 * @param bookmark
 */
const addBookmarkToNavData = (
  data: NavigationData,
  reportId: string,
  bookmark: Bookmark
): NavigationData => {
  // Deep clone navigationData to avoid mutating original
  const newNavData = JSON.parse(JSON.stringify(data));
  const reportNode = findReport(newNavData, reportId);

  if (reportNode) {
    if (!reportNode.bookmarks) {
      reportNode.bookmarks = [];
    }
    reportNode.bookmarks.push(bookmark);
  }

  return newNavData;
};

export default addBookmarkToNavData;
